import { render } from "./MobileDrawer.vue?vue&type=template&id=4804ecce&lang=pug"
import script from "./MobileDrawer.vue?vue&type=script&setup=true&lang=js"
export * from "./MobileDrawer.vue?vue&type=script&setup=true&lang=js"

import "./MobileDrawer.vue?vue&type=style&index=0&id=4804ecce&lang=sass"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__